import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import { instance, pathname } from "./ActionCreators";
import { FilterParam } from "utils/ticker-params-handler";
import notifySuccess from "utils/Notifications/Success";
import notifyError from "utils/Notifications/Error";
import FilterHandler from "utils/ticker-params-handler";
import { showModal } from "./modal";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const _ = require("lodash");

export type SelectedFilterParamsState = {
    [key: string | number]: FilterParam[];
};

export interface IState {
    loading: boolean;
    manual_query: {
        [key: string]: string;
    };
    file_query: string;
    error: null | string;
    logic: LogicState;
    query: string;
    filterParams: FilterParam[];
    filterParamsOrder?: string[];
    selectedFilterParams: SelectedFilterParamsState;
    isSortingResetTriggered: boolean;
    paramsList: {
        [key: string]: {
            value: string;
            mark: string;
        };
    };
    chosenParamsList: {
        [key: string]: {
            value: string;
            mark: string;
        };
    };
    colors: Record<string, Record<number, boolean>>;
    tickerList: any[];
}

interface LogicState {
    [key: string | number]: "*" | "+";
}

const initialState: IState = {
    loading: false,
    manual_query: {},
    file_query: "",
    filterParams: [],
    selectedFilterParams: {},
    error: null,
    logic: {},
    query: "",

    isSortingResetTriggered: false,
    paramsList: {
        virt: {
            value: "true",
            mark: "B",
        },
        stopped: {
            value: "true",
            mark: "C",
        },
        close: {
            value: "true",
            mark: "D",
        },
        mm: {
            value: "true",
            mark: "E",
        },
        no_open: {
            value: "true",
            mark: "F",
        },
    },
    chosenParamsList: {},
    colors: {},
    tickerList: [],
};

export const filterSection = createAsyncThunk<
    any,
    { query: string; section_id: number | string; closeModal?: boolean }
>(
    "post/filter_workspace",
    async ({ query, section_id, closeModal = false }, store) => {
        if (typeof query !== "string" || !section_id) {
            return;
        }
        let response;
        const body = {
            query,
            section_id,
        };
        try {
            response = await instance.post(
                pathname + "/api/filter_workspace",
                body,
            );
        } catch (error) {
            console.error(error);
            notifyError("Некорректный фильтр");
            return;
        }
        notifySuccess("Фильтр применен");
        if (closeModal) {
            store.dispatch(
                showModal({
                    modal_type: "filter",
                    value: false,
                }),
            );
            store.dispatch(
                showModal({
                    modal_type: "ticker_picker",
                    value: false,
                }),
            );
        }

        return response.data;
    },
);

export const getTickerParams = createAsyncThunk(
    "get/filter",
    async (_, store) => {
        const state = store.getState();
        //@ts-ignore
        if (!state.auth.loggedIn) {
            return;
        }

        const response = await instance.get(pathname + "/api/filter");
        //@ts-ignore
        if (!response && !(response && response.data)) {
            return;
        }
        store.dispatch(setFilterParams(response.data));
        FilterHandler.mnemonics = response.data.map((item) => ({
            name: item.name,
            letter: item.formula_letter,
            type: item.type,
        }));
        return response.data;
    },
);

export const sendFilteredColumns = createAsyncThunk<
    any,
    { columns: string[]; id: number | string }
>("patch/filter/cols", async ({ columns, id }, store) => {
    try {
        const response = await instance.patch(
            pathname + "/api/workspace_config/" + id,
            { columns: columns },
        );
        return response.data;
    } catch (e) {
        notifyError(
            Object.values(e.response?.data || {})
                .flat()
                .join(" ") ||
                e.message ||
                "Произошла ошибка",
        );
    }
});
export const saveColorsFilter = createAsyncThunk<
    any,
    { id: number | string; colors: number[] }
>("patch/workspace/colors", async ({ id, colors }) => {
    try {
        const response = await instance.patch(
            pathname + "/api/workspace_config/" + id,
            { color_filter: colors },
        );
        return response.data;
    } catch (e) {
        notifyError(
            Object.values(e.response?.data || {})
                .flat()
                .join(" ") ||
                e.message ||
                "Произошла ошибка",
        );
    }
});

export const getFilterTickers = createAsyncThunk(
    "get/changes/tickers",
    async (_, store) => {
        try {
            const response = await instance.get(
                pathname + "/api/changes/tickers",
            );

            return response.data;
        } catch (error) {
            console.error(error);
            notifyError("Не удалось загрузить список тикеров");
            return;
        }
    },
);

const filterSlice = createSlice({
    name: "filterSlice",
    initialState,
    reducers: {
        resetFilterQueries(state, action) {
            const { id } = action.payload;
            state.selectedFilterParams[id] = [];
            state.manual_query[id] = "";
            state.file_query = "";
        },
        addFilterQuery(state, action) {
            const { manual_query, caller } = action.payload;
            if (typeof manual_query === "string") {
                state.manual_query[caller] = manual_query;
                return;
            }
        },
        removeFilterParam(state, action) {
            const { id, param } = action.payload;
            const _state = current(state.selectedFilterParams);
            const place = _state[id];
            if (Array.isArray(place)) {
                state.selectedFilterParams[id] = place.filter(
                    (_param) => _param.name !== param.name,
                );
            }
        },
        setFilterParamsForWorkspace(state, action) {
            const { id, filters } = action.payload;
            if (id && Array.isArray(filters)) {
                state.selectedFilterParams[id] = filters;
            }
        },
        selectFilterParam(state, action) {
            const { id, param } = action.payload;
            if (typeof id === "string" || typeof id === "number") {
                const _state = current(state.selectedFilterParams);
                const place = _state[id];
                if (Array.isArray(place)) {
                    const existed = place.findIndex(
                        (x) => x.name === param.name,
                    );
                    if (existed !== -1) {
                        let ex = place[existed];
                        state.selectedFilterParams[id][existed] = {
                            ...ex,
                            ...param,
                        };
                        return;
                    }
                    state.selectedFilterParams[id].push(param);
                } else {
                    state.selectedFilterParams[id] = [param];
                }
            }
        },
        setSelectedFilterParams(state, action) {
            if (action.payload.columns) {
                state.selectedFilterParams[action.payload.id] =
                    action.payload.columns;
            }
        },
        resetFilterState: () => initialState,

        restoreFilter: (state) => {
            state.query = "";
        },
        setLogic: (state, action) => {
            const { id, value } = action.payload;
            state.logic[id] = value;
        },
        setFilterParams: (state, action) => {
            const sorted = action.payload.sort((a, b) => {
                return a?.name?.localeCompare(b.name);
            });
            state.filterParams = sorted;
        },

        triggerSortingReset: (state) => {
            state.isSortingResetTriggered = true;
        },
        afterTriggerSortingReset: (state) => {
            state.isSortingResetTriggered = false;
        },
        setColorsFilter: (state, action) => {
            const { id, key, value } = action.payload;

            if (!state.colors[id]) {
                state.colors[id] = {};
            }

            state.colors[id][key] = value;
        },
        initColorsFilter: (state, action) => {
            const { id, colors } = action.payload;
            if (typeof id === "undefined") return;

            const colorsArray = Array.isArray(colors) ? colors : [];

            const flags = [0, 1, 2, 3, 4, 5, 6];
            const map: Record<number, boolean> = {};

            flags.forEach((flag) => {
                map[flag] = colorsArray.includes(flag);
            });

            state.colors[String(id)] = map;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getFilterTickers.fulfilled, (state, action) => {
            if (action.payload) {
                state.tickerList = action.payload;
            }
        });
    },
});

export const {
    setSelectedFilterParams,
    initColorsFilter,
    setColorsFilter,
    afterTriggerSortingReset,
    triggerSortingReset,

    setFilterParams,
    resetFilterState,

    restoreFilter,
    setLogic,
    selectFilterParam,
    removeFilterParam,
    addFilterQuery,
    resetFilterQueries,
    setFilterParamsForWorkspace,
} = filterSlice.actions;

export default filterSlice.reducer;
